export const menu = [
  {
    id: 1,
    redirect: '/',
    class: 'active',
    title: 'Home'
  },
  {
    id: 2,
    redirect: 'pages/tutorials',
    class: '',
    title: 'Tutorials'
  },
  {
    id: 3,
    redirect: 'pages/faqs',
    class: '',
    title: 'FAQs'
  },
]
